import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import "../css/dealer.css";
import axios from "axios";
import { getAllWarranty, getAllWarrantyExport } from "../actions/formActions";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import exportFromJSON from "export-from-json";
import Loader from "../components/Loader";
import Pagination from "../components/Pagination";
import NotAuthorized from "../components/NotAuthorized";
import "../css/records.css";

const formatDate = (value) => {
  if (!value) return "--";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const WarrantyScreen = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    setSearchParams({ page }, { replace: true });
  }, [page]);

  useEffect(() => {
    dispatch(getAllWarranty(page));
  }, [dispatch, page]);

  useEffect(() => {
    dispatch(getAllWarrantyExport());
  }, []);

  const adminLogin = useSelector((state) => state.adminLogin);
  const { admin } = adminLogin;

  const getWarranty = useSelector((state) => state.getWarranty);

  useEffect(() => {
    setPageCount(getWarranty?.pagination?.pageCount || 0);
  }, [getWarranty]);

  const warrantyExport = useSelector((state) => state.warrantyExport);
  const { warranty: warrantyExportList } = warrantyExport || {};

  const resentEmail = async (index) => {
    if (window.confirm("Resend Confirmation Email ?")) {
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${admin.token}`,
          },
        };

        const { data } = await axios.post(
          "/api/form/sent-warranty-email",
          { warranty: warranty[index] },
          config,
        );

        if (data) {
          alert("MAIL SENT SUCCESSFULLY");
        }
      } catch (error) {
        alert(error);
      }
    }
  };

  const { warranty } = getWarranty;

  const exportCSV = () => {
    if (!warrantyExportList) return;
    const data = warrantyExportList.map((item) => {
      const { _id, updatedAt, __v, ...rest } = item;
      return rest;
    });
    const fileName = "warranty";
    const exportType = exportFromJSON.types.csv;
    exportFromJSON({ data, fileName, exportType });
  };
  const exportCSVDelaer = () => {
    if (!warrantyExportList) return;
    const flattenedData = warrantyExportList
      .filter((item) => item.dealerName.length)
      .map((item) => {
        // Ensure createdAt is a Date
        const createdAtDate = new Date(item.createdAt);

        // Convert UTC → IST
        const istDate = new Date(
          createdAtDate.getTime() + 5.5 * 60 * 60 * 1000,
        );

        return {
          name: item.name,
          email: item.email,
          phoneNumber: item.phoneNumber,
          frameNumber: item.frameNumber,
          dealerName: item.dealerName ? item.dealerName : "",
          date: istDate.toISOString().split("T")[0], // YYYY-MM-DD
          jackpotExpired: item.jackpot?.expired ?? "",
          jackpotPrize: item.jackpot?.prize ?? "",
          spinTheWheelURL: `https://www.emotorad.com/spin-the-wheel/${item._id}`,
        };
      });

    const fileName = "warranty";
    const exportType = exportFromJSON.types.csv;
    exportFromJSON({ data: flattenedData, fileName, exportType });
  };

  const exportPDF = async (invoiceUrl) => {
    try {
      const response = await axios.get(invoiceUrl, {
        responseType: "blob",
        headers: {
          "X-API-KEY":
            "e6254f7b55156e0fc64c559aeab4096d55a3f275b77eae80ff5693218b4556de",
        },
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "invoice.pdf";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("PDF download failed", error);
    }
  };

  const adminInfo = useSelector((state) => state.adminInfo);

  const { adminData } = adminInfo;

  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    if (!adminData) return;

    const accessLevel =
      adminData.accessLevel === "Master" || adminData.accessLevel === "Viewer";

    console.log("Access Level:", accessLevel);

    setIsAllowed(accessLevel);
  }, [adminData]);

  return (
    <div className="container-fluid  ps-0">
      <div className="row ">
        <div className="col-lg-2">
          <Sidebar active={8} />
        </div>
        {warranty ? (
          <div
            className="col-lg-10 p-0"
            style={{
              overflowY: "scroll",
              height: "100vh",
            }}
          >
            {!isAllowed ? (
              <NotAuthorized />
            ) : (
              <>
                <div className="records-page">
                  <div className="records-header-row d-flex align-items-center justify-content-between flex-wrap">
                    <h4 className="records-heading">Warranty</h4>
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "0.75em" }}
                    >
                      <button
                        onClick={exportCSV}
                        className="btn btn-success text-light records-action-btn"
                      >
                        <i class="fa-solid fa-download"></i> Export CSV
                      </button>
                      <button
                        onClick={exportCSVDelaer}
                        className="btn btn-success text-light records-action-btn"
                      >
                        <i class="fa-solid fa-store"></i> Dealer Data
                      </button>
                    </div>
                  </div>

                  <div className="records-status-bar">
                    <Pagination
                      page={page}
                      pageCount={pageCount}
                      onChange={setPage}
                    />
                    <div className="stat-pills">
                      <span className="stat-pill total">
                        <span className="stat-dot"></span>Total{" "}
                        <span className="stat-value">
                          {getWarranty?.pagination?.count ?? "--"}
                        </span>
                      </span>
                    </div>
                  </div>

                  <div className="table-card">
                    <table className="records-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Mobile Number</th>
                          <th>Bike</th>
                          <th>Source of Purchase</th>
                          <th>Frame No.</th>
                          <th>Invoice</th>
                        </tr>
                      </thead>
                      <tbody>
                        {warranty &&
                          warranty.map((item, i) => (
                            <tr key={item._id || i}>
                              <td className="cell-nowrap">
                                {formatDate(item.createdAt)}
                              </td>
                              <td>{item.name}</td>
                              <td>{item.email}</td>
                              <td className="cell-nowrap">
                                {item.phoneNumber}
                              </td>
                              <td className="cell-truncate" title={item.bike}>
                                {item.bike}
                              </td>
                              <td>{item.sourceOfPurchase}</td>
                              <td className="cell-nowrap">
                                {item.frameNumber}
                              </td>
                              <td>
                                <div
                                  className="d-flex"
                                  style={{ gap: "0.5em" }}
                                >
                                  <a
                                    href={item.invoice}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-primary records-icon-btn"
                                    title="Download invoice"
                                  >
                                    <i class="fa-solid fa-download"></i>
                                  </a>
                                  <button
                                    onClick={() => resentEmail(i)}
                                    className="btn btn-success records-icon-btn"
                                    title="Resend confirmation email"
                                  >
                                    <i class="fa-solid fa-envelope"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </div>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};

export default WarrantyScreen;
